/**
 * Translated labels of a person's access answers (5 Oct), keyed as the API
 * keys them (`security_role`, `roles`, …), for `@/lib/access-profile`.
 */

import { useT } from "@/i18n";
import { ALL_ANSWER_KEYS } from "@/lib/access-profile";

export function useAnswerLabels(): Record<string, string> {
  const { t } = useT("tickets");
  return Object.fromEntries(
    ALL_ANSWER_KEYS.map((key) => [key, t(`access.reference.answer.${key}`)]),
  );
}
